module.exports = __webpack_public_path__ + "static/media/SF-2-A (1).d057e7e7.mp3";